import React from "react";
import TopBar from "../components/TopBar";
import Footerr from "../components/Footerr/Footerr";
import RequestConfirm from "../components/Login/RequestConfirm";
import ProgressBar from "../components/ProgressBar";

function ConfirmEmailPage() {
  return (
    <div>
      <ProgressBar />
      <TopBar />
      <RequestConfirm />
      <Footerr />
    </div>
  );
}

export default ConfirmEmailPage;
